<template>
    <div v-html="time"></div>
</template>

<script>
export default {
  name: 'TimeDisplay',
  props: {
    time: {
      type: String,
      required: true,
      default: ''
    }
  }
}
</script>